"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runtime = void 0;
exports.runtime = {
    EVMRuntimeRPCApi: [
        {
            version: 2,
            methods: {
                call: {
                    description: 'call evm contract',
                    params: [
                        {
                            name: 'from',
                            type: 'H160'
                        },
                        {
                            name: 'to',
                            type: 'H160'
                        },
                        {
                            name: 'data',
                            type: 'Vec<u8>'
                        },
                        {
                            name: 'value',
                            type: 'Balance'
                        },
                        {
                            name: 'gas_limit',
                            type: 'u64'
                        },
                        {
                            name: 'storage_limit',
                            type: 'u32'
                        },
                        {
                            name: 'access_list',
                            type: 'Option<Vec<EthereumTransactionAccessListItem>>'
                        },
                        {
                            name: 'estimate',
                            type: 'bool'
                        }
                    ],
                    type: 'Result<CallInfo, sp_runtime::DispatchError>'
                },
                create: {
                    description: 'create evm contract',
                    params: [
                        {
                            name: 'from',
                            type: 'H160'
                        },
                        {
                            name: 'data',
                            type: 'Vec<u8>'
                        },
                        {
                            name: 'value',
                            type: 'Balance'
                        },
                        {
                            name: 'gas_limit',
                            type: 'u64'
                        },
                        {
                            name: 'storage_limit',
                            type: 'u32'
                        },
                        {
                            name: 'access_list',
                            type: 'Option<Vec<EthereumTransactionAccessListItem>>'
                        },
                        {
                            name: 'estimate',
                            type: 'bool'
                        }
                    ],
                    type: 'Result<CreateInfo, sp_runtime::DispatchError>'
                },
                block_limits: {
                    description: 'evm block limits',
                    params: [],
                    type: 'BlockLimits'
                }
            }
        }
    ]
};
